import { SuiteManifest } from '../manifest';
import { crmRoutes } from './routes';

export const crmManifest: SuiteManifest = {
  id: 'crm',
  code: 'S5_CRM',
  name: 'CRM & Admissions',
  basePath: '/crm',
  icon: 'briefcase',
  description: 'Public lead capture forms, MMTSE talent search scholarship exams, study consultations, tuition demand bidding, and counselor pipelines.',
  requiredPermission: 'crm.read',
  allowedRoles: ['owner', 'admin', 'branch_head', 'counselor'],
  nav: [
    { label: 'Leads Pipeline', path: '/crm/leads', icon: 'trending-up', group: 'Pipeline', status: 'live' },
    { label: 'Scholarship Exam (MMTSE)', path: '/crm/scholarships', icon: 'award', group: 'Admissions & Competitions', status: 'live' },
    { label: 'Referrals & Affiliates', path: '/crm/referrals', icon: 'share-2', group: 'Admissions & Competitions', status: 'live' },
    { label: 'Study Consultations', path: '/crm/consultations', icon: 'sparkles', group: 'Tuition Inquiries', status: 'live' },
    { label: 'Tuition Demands & Bidding', path: '/crm/tuition-requests', icon: 'briefcase', group: 'Tuition Inquiries', status: 'live' },
    { label: 'Counselor Pools', path: '/crm/counselors', icon: 'user-check', group: 'Pipeline', status: 'live' },
    { label: 'Lead Scoring Rules', path: '/crm/scoring', icon: 'sliders', group: 'Configuration', status: 'live' },
    { label: 'Campaigns & Sources', path: '/crm/campaigns', icon: 'send', group: 'Marketing', status: 'live' },
  ],
  routes: crmRoutes,
};

export { crmRoutes } from './routes';
export default crmManifest;

